import React from 'react';
import styled from "styled-components";

const ContactLink = styled.a`
  // color: #637282;
  font-size: 1rem; /* Cùng kích thước font */
  font-weight: 500;
  text-decoration: underline 1px solid; /* underline dày hơn */
  cursor: pointer;
  display: inline-block;
  // padding: 6px 12px;
  // border-radius: 4px;
  // transition: color 0.3s ease, background-color 0.3s ease;
  text-transform: none;
  padding: 0;
  display: inline;
  &:hover {
    color: #689AB9 !important;
    background-color: transparent;
    text-decoration: underline 2px solid; /* giữ underline khi hover */
  }

  &:focus {
    outline: none;
    // box-shadow: 0 0 0 3px rgba(104, 154, 185, 0.5);
    color: #689AB9 !important;
  }
`;

function ErrorNotice({ error, setError }) {
  const mailjet_formRef = React.useRef(window?.drupalSettings?.mailjet_form);
  
  React.useEffect(() => {
    if (!mailjet_formRef.current && !!window?.drupalSettings?.mailjet_form) {
      mailjet_formRef.current = window?.drupalSettings?.mailjet_form;
    }
  }, []);

  if (!error) return null; // Không hiển thị nếu không có lỗi
  if ((Number(error?.reponse?.status) === 401)) return <></>;

  // Hàm xử lý click mở modal hoặc hành vi cần thiết
  const handleClick = (target) => (e) => {
    e.preventDefault();
    // Giả định gọi modal theo data-target hoặc logic tương tự
    // Ví dụ:
    const modalSelector = target;
    if (modalSelector) {
      const modalElement = document.querySelector(modalSelector);
      if (modalElement) {
        // Giả sử modal dùng class 'show', tùy thư viện có thể phải trigger khác
        modalElement.classList.add('show');
      }
    }
  };

  return (
    <div 
      style={{
        // --- Styles for Centering the Whole Block ---
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center', // This will center the <h4> and the button div
        padding: '24px',
        boxSizing: 'border-box'
      }}
    >
      <h5 style={{ marginBottom: '1rem' }}>Oops! Something went wrong</h5>
      
      {/* Set a max-width and align text to the left */}
      <p style={{ maxWidth: '550px', textAlign: 'left' }}>
        It looks like you don't have access to this content. This might happen if a subscription for 3rd party content has ended or is not included in your current license.
      </p>
      
      {/* Use the same max-width and left alignment for the list */}
      <ul style={{ maxWidth: '550px', width: '100%', textAlign: 'left', listStylePosition: 'outside', paddingLeft: '20px', margin: '0 0' }}>
        <li>
          If you believe you should have access, please contact our{' '}
          <ContactLink
            href="#"
            // onClick={handleClick(mailjet_formRef.current?.contact_us)}
            // className="dashboard-content-block hubspot-modal--contact-us"
            data-toggle="modal"
            data-target={
              `${mailjet_formRef.current?.contact_us}`
            }
          >
            {"support."}
          </ContactLink>
        </li>
        <li>
          If you'd like to renew or upgrade your subscription, our{' '}
          <ContactLink
            href="#"
            data-toggle="modal"
            data-target={
              `${mailjet_formRef.current?.contact_sale}`
            }
            // onClick={handleClick(mailjet_formRef.current?.contact_sale)}
            // className="dashboard-content-block hubspot-modal--contact-us contact-us-link"
          >
            {"sales team"}
          </ContactLink>{' '}is happy to help.
        </li>
      </ul>
      <h5>Make the future yours!</h5>
      {/* <div style={{ marginTop: 12, textAlign: 'center' }}>
        <button onClick={() => setError(null)} className='btn btn-primary btn-md' 
        >
          OK
        </button>
      </div> */}
    </div>
  );
}

export default ErrorNotice;
